import '@google/model-viewer';
import React, { Component } from 'react';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import "./meta.style.css";
import axios from 'axios';

export default class InfoHtmlIndoorView extends Component {
    constructor() {
        super();
        this.state = {
            html: ""
        }
    }

    componentDidMount() {
        axios.get(this.props.filePath).then((res) => {
            this.setState({ html: res.data });
        })
    }

    render() {
        return <div className="info-panel-indoor">
            <div className="content" dangerouslySetInnerHTML={{ __html: this.state.html }} />
        </div>
    }
}
